export default "__VITE_ASSET__1339e0e9__"